import voucherHorizontalCh from './Horizontal-bar/voucher_banner_bottombar_ch.jpg';
import voucherHorizontalKr from './Horizontal-bar/voucher_banner_bottombar_kr.jpg';
import voucherMainCh from './Main-card/voucher_banner_main_ch.jpg';
import voucherMainKr from './Main-card/voucher_banner_main_kr.jpg';
import voucherPopupsquareCh from './Popup-square/voucher_banner_popup_ch.jpg';
import voucherPopupsquareKr from './Popup-square/voucher_banner_popup_kr.jpg';

import telecomPlanHorizontalKr from './Horizontal-bar/telecom_plan_banner_bottombar_656x144_kr.jpg';
import telecomPlanHorizontalCh from './Horizontal-bar/telecom_plan_banner_bottombar_656x144_ch.jpg';
import telecomPlanMainKr from './Main-card/telecom_plan_banner_main_kr.jpg';
import telecomPlanMainCh from './Main-card/telecom_plan_banner_main_ch.jpg';
import telecomPlanPopupsquareKr from './Popup-square/telecom_plan_banner_popup_1080x1080_kr.jpg';
import telecomPlanPopupsquareCh from './Popup-square/telecom_plan_banner_popup_1080x1080_ch.jpg';

import tripDotComHorizontalKr from './Horizontal-bar/trip_banner_bottombar_kr.jpg';
import tripDotComHorizontalEn from './Horizontal-bar/trip_banner_bottombar_en.jpg';
import tripDotComHorizontalCh from './Horizontal-bar/trip_banner_bottombar_ch.jpg';
import tripDotComMainKr from './Main-card/trip_banner_main_kr.jpg';
import tripDotComMainEn from './Main-card/trip_banner_main_en.jpg';
import tripDotComMainCh from './Main-card/trip_banner_main_ch.jpg';
import tripDotComPopupsquareKr from './Popup-square/trip_banner_popup_kr.jpg';
import tripDotComPopupsquareEn from './Popup-square/trip_banner_popup_en.jpg';
import tripDotComPopupsquareCh from './Popup-square/trip_banner_popup_ch.jpg';

import apMTradingHorizontal from './Horizontal-bar/trading_banner_bottombar_new.jpg';
import apMTradingMain from './Main-card/trading_banner_main_new.jpg';
import apMTradingPopupsquare from './Popup-square/trading_banner_popup_new.jpg';

import exchangeHorizontalKr from './Horizontal-bar/exchange_banner_bottombar_kr.jpg';
import exchangeHorizontalCh from './Horizontal-bar/exchange_banner_bottombar_ch.jpg';
import exchangeMainKr from './Main-card/exchange_banner_main_kr.jpg';
import exchangeMainCh from './Main-card/exchange_banner_main_ch.jpg';
import exchangePopupsquareKr from './Popup-square/exchange_banner_popup_kr.jpg';
import exchangePopupsquareCh from './Popup-square/exchange_banner_popup_ch.jpg';

import irisHorizontalEn from './Horizontal-bar/new_iris_banner_bottombar_en.jpg';
import irisHorizontalCh from './Horizontal-bar/new_iris_banner_bottombar_ch.jpg';
import irisMainEn from './Main-card/new_iris_banner_main_en.jpg';
import irisMainCh from './Main-card/new_iris_banner_main_ch.jpg';
import irisPopupsquareEn from './Popup-square/new_iris_banner_popup_en.jpg';
import irisPopupsquareCh from './Popup-square/new_iris_banner_popup_ch.jpg';

export const horizontalbarImage = {
  discountVoucherHorizontal: {
    kor: voucherHorizontalKr,
    eng: voucherHorizontalCh,
    chi: voucherHorizontalCh,
  },
  telecomPlanHorizontal: {
    kor: telecomPlanHorizontalKr,
    eng: telecomPlanHorizontalKr,
    chi: telecomPlanHorizontalCh,
  },
  tripDotComHorizontal: {
    kor: tripDotComHorizontalKr,
    eng: tripDotComHorizontalEn,
    chi: tripDotComHorizontalCh,
  },
  apMTradingHorizontal: {
    kor: apMTradingHorizontal,
    eng: apMTradingHorizontal,
    chi: apMTradingHorizontal,
  },
  exchangeHorizontal: {
    kor: exchangeHorizontalKr,
    eng: exchangeHorizontalCh,
    chi: exchangeHorizontalCh,
  },
  irisHorizontal: {
    kor: irisHorizontalEn,
    eng: irisHorizontalEn,
    chi: irisHorizontalCh,
  },
}

export const maincardImage = {
  discountVoucherMain: {
    kor: voucherMainKr,
    eng: voucherMainCh,
    chi: voucherMainCh,
  },
  telecomPlanMain: {
    kor: telecomPlanMainKr,
    eng: telecomPlanMainKr,
    chi: telecomPlanMainCh,
  },
  tripDotComMain: {
    kor: tripDotComMainKr,
    eng: tripDotComMainEn,
    chi: tripDotComMainCh,
  },
  apMTradingMain: {
    kor: apMTradingMain,
    eng: apMTradingMain,
    chi: apMTradingMain,
  },
  exchangeMain: {
    kor: exchangeMainKr,
    eng: exchangeMainCh,
    chi: exchangeMainCh,
  },
  irisMain: {
    kor: irisMainEn,
    eng: irisMainEn,
    chi: irisMainCh,
  },
}

export const popupsquareImage = {
  discountVoucherPopupsquare: {
    kor: voucherPopupsquareKr,
    eng: voucherPopupsquareCh,
    chi: voucherPopupsquareCh,
  },
  telecomPlanPopupsquare: {
    kor: telecomPlanPopupsquareKr,
    eng: telecomPlanPopupsquareKr,
    chi: telecomPlanPopupsquareCh,
  },
  tripDotComPopupsquare: {
    kor: tripDotComPopupsquareKr,
    eng: tripDotComPopupsquareEn,
    chi: tripDotComPopupsquareCh,
  },
  apMTradingPopupsquare: {
    kor: apMTradingPopupsquare,
    eng: apMTradingPopupsquare,
    chi: apMTradingPopupsquare,
  },
  exchangePopupsquare: {
    kor: exchangePopupsquareKr,
    eng: exchangePopupsquareCh,
    chi: exchangePopupsquareCh,
  },
  irisPopupsquare: {
    kor: irisPopupsquareEn,
    eng: irisPopupsquareEn,
    chi: irisPopupsquareCh,
  },
}
